import Button from '@shared/components/Button/Button';
import React from 'react';

import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import { IconType } from 'utils/types';

interface ManagementActionSectionProps {
  title: string;
  description: string;
  buttonIcon: IconType;
  onClick: () => void;
}

const ManagementActionSection = ({ title, description, buttonIcon, onClick }: ManagementActionSectionProps) => (
  <div className="flex gap-4 flex-col md:flex-row items-center justify-between">
    <div className="flex flex-col space-y-1">
      <SettingsCard.Content.Title>{title}</SettingsCard.Content.Title>
      <SettingsCard.Content.Description>{description}</SettingsCard.Content.Description>
    </div>
    <Button
      size="sm"
      variant="destructive"
      iconRight={{ icon: buttonIcon, className: 'w-5 h-5 stroke-current stroke-1.5' }}
      onClick={onClick}
      className="w-full md:w-fit"
    >
      {title}
    </Button>
  </div>
);

export default ManagementActionSection;
